import { ProductsDataActions } from '@msdyn365-commerce/retail-proxy';
import { useCallback, useState } from 'react';
import * as React from 'react';
import { IHeiDonationViewProps } from './hei-donation';
import { getCartState } from '@msdyn365-commerce/global-state';

const HeiDonationView = (props: IHeiDonationViewProps) => {
    const { resources, config, context } = props;
    const {
        actionContext,
        request: { apiSettings }
    } = context;

    const [isLoading, setIsLoading] = useState(false);

    const onClick = useCallback(
        async (sku?: string) => {
            setIsLoading(true);

            try {
                const products = await ProductsDataActions.searchByTextAsync(
                    {
                        callerContext: actionContext
                    },
                    apiSettings.channelId,
                    apiSettings.catalogId,
                    sku
                );

                const product = products.find(p => p.ItemId === sku);

                if (product) {
                    const productToAdd = await ProductsDataActions.getByIdAsync(
                        {
                            callerContext: actionContext
                        },
                        product.RecordId,
                        apiSettings.channelId
                    );

                    const cartState = await getCartState(props.context.actionContext);
                    await cartState.addProductToCart({
                        product: productToAdd
                    });
                }
            } finally {
                setIsLoading(false);
            }
        },
        [actionContext, apiSettings]
    );

    return (
        <div className='hei-donation row'>
            <div className='col-6'>
                <h3>{resources.heiDonationHeader}</h3>
                <p>{resources.heiDonationText}</p>
            </div>
            <div className='col-2'>
                {config.donation1Sku && (
                    <button
                        className='msc-btn'
                        disabled={isLoading}
                        onClick={() => onClick(config.donation1Sku)}
                        aria-label={resources.heiDonation1BtnText}
                    >
                        {resources.heiDonation1BtnText}
                    </button>
                )}
            </div>
            <div className='col-2'>
                {config.donation2Sku && (
                    <button
                        className='msc-btn'
                        disabled={isLoading}
                        onClick={() => onClick(config.donation2Sku)}
                        aria-label={resources.heiDonation2BtnText}
                    >
                        {resources.heiDonation2BtnText}
                    </button>
                )}
            </div>
            <div className='col-2'>
                {config.donation3Sku && (
                    <button
                        className='msc-btn'
                        disabled={isLoading}
                        onClick={() => onClick(config.donation3Sku)}
                        aria-label={resources.heiDonation3BtnText}
                    >
                        {resources.heiDonation3BtnText}
                    </button>
                )}
            </div>
        </div>
    );
};

export default HeiDonationView;
